// URL of the scanning guide PDF
export const scanGuideUrl = 'https://samples.bandicootimaging.com.au/guide/Bandicoot_scanning_guide_9-shot_web.pdf';
export const importGuideUrl = 'https://bandicoot.notion.site/Texture-Import-Guide-ac40d31bec90495ba482d48516c7f7f1';
export const fullTileGuideUrl = 'https://samples.bandicootimaging.com.au/guide/Bandicoot_tiling_guide.pdf';
export const lowTouchTileGuideUrl = 'https://bandicoot.notion.site/Low-touch-tiling-1453bf8f18c280f18991c76f489a6737';
export const stitchingGuideUrl = 'https://bandicoot.notion.site/Stitching-tool-cb2331d086d543b0a4239f294bec9d5f';
export const bookingUrl = 'https://www.bandicootimaging.com/connect/with/matthew';
export const servicedUrl = 'https://www.bandicootimaging.com/connect/solution/serviced-scanning';
export const helpUrl = 'https://bandicoot.notion.site/';
